const gameNames = [
  {
    id: 1,
    name: "MyelinFace",
    slug: "myelin-face",
    type: "App"
  },
  {
    id: 2,
    name: "Athena",
    slug: "athena",
    type: "Game"
  },
  {
    id: 3,
    name: "Sophia",
    slug: "sophia",
    type: "Game"
  },
  {
    id: 4,
    name: "Clionia",
    slug: "clionia",
    type: "Game"
  },
  {
    id: 5,
    name: "Mnemonica",
    slug: "mnemonica",
    type: "Game"
  },
  {
    id: 6,
    name: "Sophonia",
    slug: "sophonia",
    type: "Game"
  },
  {
    id: 7,
    name: "Dromia",
    slug: "dromia",
    type: "Game"
  },
  {
    id: 8,
    name: "Aeolia",
    slug: "aeolia",
    type: "Game"
  },
  {
    id: 10,
    name: "Kratoria",
    slug: "kratoria",
    type: "Game"
  },
  {
    id: 11,
    name: "Harmonia",
    slug: "harmonia",
    type: "Game"
  },
  {
    id: 12,
    name: "Physia",
    slug: "physia",
    type: "Game"
  },
  {
    id: 13,
    name: "Orphia",
    slug: "orphia",
    type: "Game"
  },
  {
    id: 14,
    name: "Eudaimonia",
    slug: "eudaimonia",
    type: "Game"
  },
  {
    id: 15,
    name: "Phantasia",
    slug: "phantasia",
    type: "Game"
  },
  {
    id: 16,
    name: "Atalanta",
    slug: "atalanta",
    type: "Game"
  },
  {
    id: 17,
    name: "MoodMirror",
    slug: "mood-mirror",
    type: "App"
  },
  {
    id: 18,
    name: "Checkers",
    slug: "checkers",
    type: "Game"
  }
];

export default gameNames; 